import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>
              {new Date().getFullYear()} © {process.env.REACT_APP_COMPANY_NAME}
            </Col>
            <Col md={6}>
              <div className="text-sm-end">
                Develop by {process.env.REACT_APP_DEV_COMPANY}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
